import { createApp } from "vue";
import PhosphorIcons from "@phosphor-icons/vue";
import App from "./App.vue";
import router from "./router";
import "./assets/style.css";
import "./registerServiceWorker";
import { MotionPlugin } from "@vueuse/motion";
console.log("updated here");
createApp(App).use(MotionPlugin).use(PhosphorIcons).use(router).mount("#app");
